/* eslint-disable no-console */
import {Flex} from 'antd';
import React, {Fragment} from 'react';

import {roundToDecimal} from '../../constants/commonFunctions';

import FlexLegend from './FlexLegend';
import LineLegend from './LineLegend';

const ChartLabelComponent: React.FC<{
  data: any;
  total: {unit: string; value: number | string};
  showTotal?: boolean;
  mainTitle?: string;
  type?: 'line' | 'flex';
  isValue?: boolean;
  customTotalTitle?: string;
  convertToTJ?: boolean;
}> = ({
  data,
  total: {unit, value},
  showTotal = true,
  mainTitle = 'EMISSIONS',
  type = 'line',
  isValue = true,
  customTotalTitle = '',
  convertToTJ = false
}) => {
  return (
    <div className="chartLabelData">
      {showTotal && (
        <Flex className="titleData">
          <div className="titleDataText">
            {customTotalTitle !== '' ? customTotalTitle : `TOTAL ${mainTitle}`}
          </div>
          <div className="titleDataValue">
            {`${
              typeof value === 'string' ? value : roundToDecimal(value ?? 0)
            } `}
            <span>{unit ?? ''}</span>
          </div>
        </Flex>
      )}
      <Flex vertical={true}>
        {data?.map((item: any, index: number) => {
          return (
            <Fragment key={index}>
              {type === 'line' ? (
                <LineLegend index={index} item={item} length={data?.length} convertToTJ={convertToTJ}/>
              ) : (
                <FlexLegend index={index} item={item} isValue={isValue} convertToTJ={convertToTJ}/>
              )}
            </Fragment>
          );
        })}
        <></>
      </Flex>
    </div>
  );
};

export default ChartLabelComponent;
